module.exports = __webpack_public_path__ + "img/application-pattern.1ca06a79.jpg";